import React from 'react'
import ChatBot from 'react-simple-chatbot';
import DownloadButton from "../DownloadButton";
import { ThemeProvider } from 'styled-components';

function SimpleForm() {

    const theme = {
        background: '#23272a',
        fontFamily: 'Arial, Helvetica, sans-serif',
        headerBgColor: '#000',
        headerFontColor: 'whitesmoke',
        headerFontSize: '14px',
        botBubbleColor: '#6e48aa',
        botFontColor: 'whitesmoke',
        userBubbleColor: '#e00097',
        userFontColor: 'whitesmoke',
        overflow: 'hidden',
    };


    return (
        <ThemeProvider theme={theme}>
            <ChatBot
                headerTitle="Corey Calhoun"
                speechSynthesis={{ enable: false, lang: 'en' }}
                steps={[
                    {
                        id: '1',
                        message: 'Hello, my name is Corey. What is your name?',
                        trigger: '2',
                    },
                    {
                        id: '2',
                        user: true,
                        trigger: '3',
                    },
                    {
                        id: '3',
                        message: 'Hi {previousValue}, nice to meet you! How can I help you today?',
                        trigger: '4',
                    },
                    {
                        id: '4',
                        options: [
                            { value: 1, label: 'I need a website', trigger: '5' },
                            { value: 2, label: 'I am a recruiter', trigger: '7' },
                            { value: 3, label: 'I need something else', trigger: '6' },
                        ],
                    },
                    {
                        id: '5',
                        message: 'Ok, what type of website do you need?',
                        trigger: '6',
                    },
                    {
                        id: '6',
                        options: [
                            { value: 1, label: 'E-Commerce', trigger: '7' },
                            { value: 2, label: 'No E-Commerce', trigger: '8' },
                        ],
                    },
                    {
                        id: '7',
                        component: (
                            <DownloadButton />
                        ),
                        trigger: '48',
                    },
                    {
                        id: '8',
                        component: (
                            <div> This is another example component </div>
                        ),
                        trigger: '48',
                    },
                    {
                        id: '48',
                        message: 'Is there anything else I can help with?',
                        trigger: '49'
                    },
                    {
                        id: '49',
                        options: [
                            { value: 1, label: 'Yes, schedule an appointment', trigger: '50' },
                            { value: 2, label: 'No thank you.', trigger: '51' },
                        ],
                    },
                    {
                        id: '50',
                        message: 'Thank you for stopping by!',
                        end: true,
                    },
                    {
                        id: '51',
                        message: 'Thank you for stopping by!',
                        end: true,
                    },
                ]}
            />
        </ThemeProvider>
    )
}

export default SimpleForm
